<template>
    <div class="xcard ztablita">
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
        <h5 class="text-center"> Completar los datos faltantes </h5>
        <v-row class="justify-center">
            <v-col sm="4" md="2">
                <v-checkbox v-model="filtrar_wobi" label="ocultar wobi"></v-checkbox>
            </v-col>
            <v-col sm="4" md="2">
                <v-combobox v-model="gestion" :items="gestiones" label="Gestion" :item-value="'gestion'" :item-text="'gestion'" :loading="loading_gestiones" :disabled="loading_gestiones" hide-details outlined dense></v-combobox>
            </v-col>
            <v-col sm="4" md="3">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="filtrar..." dense single-line hide-details outlined></v-text-field>
            </v-col>
        </v-row>

        <div cstyle="max-height: 55vh;overflow-y: scroll;">
            <v-data-table :headers="headers" :loading="loading" :search="search" :items="desserts" height="75vh" fixed-header disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
                <template v-slot:item.sede="{ item }">
                    {{ item.sede }}
                </template>

                <template v-slot:header.codigo="{ header }">
                    <span style="max-width: 200px;"> {{ header.text }} </span>
                </template>
                <template v-slot:header.nombre_compuesto="{ header }">
                    <span style="width: 100%;min-width: 120px;"> {{ header.text }} </span>
                </template>

                <template v-slot:item.codigo="{ item }">
                    <v-text-field style="max-width: 200px;min-width: 150px;" v-model="item.codigo" dense outlined hide-details></v-text-field>
                </template>
                <template v-slot:item.nombre_corto="{ item }">
                    <v-text-field style="width: 100%;" v-model="item.nombre_corto" dense outlined counter></v-text-field>
                </template>
                <template v-slot:item.fase="{ item }">
                    <p :style="getFaseColor(item.xfase)">
                        <small> {{ item.fase }} </small>
                    </p>
                </template>

                <template v-slot:item.opt="{ item }">
                    <v-btn small @click="savedata(item)" :loading="item.xloading" color="green" dark>
                        <v-icon>mdi-content-save-all</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<style>
.ztablita th:nth-child(4){ 
    width: 95%;
}
</style>


<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios'

  export default {
    data: () => ({
      loading: false,
      loading_gestiones: false,
      filtrar_wobi: true,
      headers: [ 
          { text: 'Sede', value: 'sede' },
          { text: 'Codigo contable', value: 'codigo' },
          { text: 'Nombre compuesto', value: 'nombre_compuesto' },
          { text: 'Nombre corto', value: 'nombre_corto' },
          { text: 'Fase', value: 'fase' },
          { text: '', value: 'opt' },
        ],
        desserts:[],
        gestiones:[],
        gestion: null,
        search: '',
    }),
    components: {},
    watch:{
        gestion: function(){
            this.getDatos();
        },
        filtrar_wobi: function(){
            this.getDatos();
        },
        '$store.state.CARGO': function(){
            this.getDatos();
        }
    },
    methods: { 
        async savedata(item){
            let msg = '';
            if(!item.codigo) msg = "Debe ingresar el codigo contable para guardar";
            if(!item.nombre_corto) msg = "Debe ingresar un nombre corto para el programa";
            if(item.nombre_corto && item.nombre_corto.length > 60) msg = "El nombre corto del programa no debe ser mayor a 60 caracteres.";
            
            if(msg){
                this.$root.$notify.show(msg, {color:'red',x: 'right',});
                return;
            }
            let data = { 
                programa_id: item.xprograma_id,
                codigo: item.codigo,
                nombre_corto: item.nombre_corto
            } 
            item.xloading = true;

            let url = `${process.env.VUE_APP_API_REST}/api/esam/programa/actualizar`; 
            const res = await xaxios.put(url, data).then(x=>x).catch(x=>x);
            if(res && res.response){
                let er = res.response.data.error; 
                this.$root.$notify.show(er, {color:'red',x: 'right',});
                item.xloading = false;
                return;
            }
            if(res && res.data){
                let ex = res.data.result;
                if(ex == "success"){
                    this.$root.$notify.show('Guardado', {color:'green',x: 'right',});
                }else{
                    this.$root.$notify.show(ex, {color:'red',x: 'right',});
                }
            }
            item.xloading = false; 
        },
        getFase(fase) {
            if (fase == 0) return 'NO APROBADO';
            else if (fase == 1) return 'INSCRIPCIONES';
            else if (fase == 2) return 'EN DESARROLLO';
            else if (fase == 3) return 'CONCLUIDO';
            else if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
            else if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
            else if (fase == 6) return 'ARMADO CARPETAS';
            else if (fase == 7) return 'PAGO ARANCELES';
            else if (fase == 8) return 'PROCESO TITULACION';
            else if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
            else if (fase == 10) return 'NO EJECUTADO';
            else return 'DESCONOCIDO: ' + fase;
        },
        getFaseColor(fase) {
            if (fase == 0) return 'background:#F2DEDE';
            else if (fase == 1) return 'background:#D9F0D9';
            else if (fase == 2) return 'background:#A8FFA8';
            else if (fase == 3) return 'background:#EFFFA8';
            else if (fase == 4) return 'background:#FFC8A8';
            else if (fase == 5) return 'background:#E3F2FD';
            else if (fase == 6) return 'background:#FFFDE7';
            else if (fase == 7) return 'background:#FFEBEE';
            else if (fase == 8) return 'background:#F9FBE7';
            else if (fase == 9) return 'background:#EFEBE9';
            else return '';
        },
        async getDatos(){
            if(!this.gestion) return;
            this.desserts = [];
            this.loading = true;
            let sede = this.$store.state.CARGO.sede.id;
            let sql = gql`query{ getProgramas(cursor:100000000,estado:true,idsede:${sede}, gestion:${this.gestion.gestion} ){ id, course_category_id,fase,codigo,nombre_compuesto,nombre_corto, sede{nombre}} }`;
            let res = await this.$apollo.query({ query: sql }).then(({ data }) => data)
            let datos = res.getProgramas;
            if(!datos) datos = [];
            let xs = [];

            datos.forEach(x=>{
                if(this.filtrar_wobi){
                    if(!x.nombre_compuesto.toLowerCase().includes('wobi')){
                        xs.push(
                            {
                                sede: x.sede.nombre,
                                gestion: x.gestion,
                                codigo: x.codigo,
                                nombre_compuesto: x.nombre_compuesto,
                                nombre_corto: x.nombre_corto,
                                fase: this.getFase(x.fase),
                                xfase: x.fase,
                                xprograma_id: x.id,
                                xloading: false,
                            }
                        )
                    }
                }else{
                    xs.push(
                            {
                                sede: x.sede.nombre,
                                gestion: x.gestion,
                                codigo: x.codigo,
                                nombre_compuesto: x.nombre_compuesto,
                                nombre_corto: x.nombre_corto,
                                fase: this.getFase(x.fase),
                                xfase: x.fase,
                                xprograma_id: x.id,
                                xloading: false,
                            }
                        )
                }
                
            });
            xs.sort((a, b) => {
                /* if (!a.codigo && b.codigo) return -1; 
                else if (a.codigo && !b.codigo) return 1;
                else return a.xfase - b.xfase; */
                if (!a.codigo && b.codigo) return -1;
                if (a.codigo && !b.codigo) return 1;

                if (!a.nombre_corto && b.nombre_corto) return -1;
                if (a.nombre_corto && !b.nombre_corto) return 1;

                return a.xfase - b.xfase;
            });
            this.desserts = xs;
            this.loading = false;
        },
        async getgestiones(){
            this.loading_gestiones = true;
            let sql = gql`query{ getGestiones{ gestion } }`;
            let res = await this.$apollo.query({ query: sql }).then(({ data }) => data);
            this.gestiones = res.getGestiones.reverse();
            this.gestion = this.gestiones[0];
            this.loading_gestiones = false;
        },
    },
    mounted() { 
        this.getgestiones();
    },
  };
</script>
